
const digest = 'c6ad3a2f8e7d3bf147e37b2456cc95a7df16afd7243624755308770be7d74303';
const classes = {"item":"_item_146il_1","header":"_header_146il_9","title":"_title_146il_15","requisitions":"_requisitions_146il_24","requisition":"_requisition_146il_24","buttons":"_buttons_146il_39"};
const css = `._item_146il_1 {
  font-family: Rubik, sans-serif;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
._item_146il_1 ._header_146il_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px;
}
._item_146il_1 ._header_146il_9 ._title_146il_15 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
  flex-grow: 1;
}
._item_146il_1 ._requisitions_146il_24 {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #d1d4da;
  padding: 24px;
  gap: 10px;
}
._item_146il_1 ._requisitions_146il_24 ._requisition_146il_24 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}

._buttons_146il_39 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  